import Table from 'react-bootstrap/Table';


function Tabla() {
  return (
  
            <Table responsive="sm" variant="dark">
              <thead>
                <tr>
                  <th type="date">Fecha</th>
                  <th>Menú general</th>
                  <th>Menú vegetariano</th>
                  <th>Menú Light(ensaladas)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>01/05/2023</td>
                  <td>Mark</td>
                  <td>Otto</td>
                  <td>@mdo</td>
                  
                </tr>
                <tr>             
                  <td >02/05/2023</td>
                  <td>Jacob</td>
                  <td>Thornton</td>
                  <td>@fat</td>
                  
                </tr>
                <tr>
                  <td>03/05/2023</td>
                  <td colSpan={1}>Larry the Bird</td>
                  <td>@twitter</td>
                  <td></td>
                  
                </tr>
                <tr>
                  <td>04/05/2023</td>
                  <td colSpan={1}>Larry the Bird</td>
                  <td>@twitter</td>
                  <td></td>
                  
                </tr>
              </tbody>
            </Table>
         
       
    
           
      
  );
}

export default Tabla;